import styled from 'styled-components';

export const Caption = styled.div`
  padding: 5px 15px;
`;
